<template>
    <AccordionBasic
        title="investment_desk_settings"
        :help="help_investment_desk_settings"
    >
        <div class="mt-4 space-y-4">
            <!-- Select for single_campaign_style -->
            <SelectField
                v-model="localSettings.single_campaign_style"
                name="single_campaign_style"
                :label="$t('single_campaign_style')"
                :options="[
                    { value: 'style_1', label: 'Style 1' },
                    { value: 'style_2', label: 'Style 2' },
                ]"
                @update:model-value="updateSettings"
            />

            <!-- Toggle switches for boolean values -->
            <div
                v-for="(value, key) in localSettings"
                :key="key"
            >
                <template v-if="typeof value === 'boolean'">
                    <ToggleSwitch
                        v-model="localSettings[key]"
                        :name="key"
                        :label="key"
                        @update:model-value="updateSettings"
                    />
                </template>
                <template
                    v-else-if="
                        key === 'wallet_currency' ||
                        key === 'redirect_url_after_login' ||
                        key === 'login_only_via_external_identity_provider' ||
                        key === 'queue_it_customer_id'
                    "
                >
                    <TextField
                        v-model="localSettings[key]"
                        :name="key"
                        :label="key"
                        @update:model-value="updateSettings"
                    />
                </template>
            </div>
        </div>
    </AccordionBasic>
</template>

<script setup lang="ts">
import AccordionBasic from '@src/components/AccordionBasic.vue'
import SelectField from '@src/components/SelectField.vue'
import TextField from '@src/components/TextField.vue'
import ToggleSwitch from '@src/components/ToggleSwitch.vue'
import { PlatformInvestmentDeskSettings } from '@src/types'
import { ref, watch } from 'vue'

const props = defineProps<{
    settings: PlatformInvestmentDeskSettings
}>()

const emit = defineEmits<{
    (e: 'update:settings', value: PlatformInvestmentDeskSettings): void
}>()

const localSettings = ref<PlatformInvestmentDeskSettings>({ ...props.settings })

// Watch for changes in props.settings
watch(
    () => props.settings,
    (newSettings) => {
        localSettings.value = { ...newSettings }
    },
    { deep: true }
)

// Update parent when local settings change
function updateSettings() {
    emit('update:settings', localSettings.value)
}
</script>
